import type { IContainer } from '@monofe/di';
import action from './actions';
import type { IModuleState } from './interface';
import store from './store';
export * from './interface';

function ModuleState(container: IContainer): IModuleState {
    const state = store(container);

    state.setup();

    return {
        useStore: state.useStore,
        getState: state.getStore,
        action: action(state.dispatchAction),
    };
}

export default ModuleState;
